
export default {
  name: "the-number-in-use",
  props: {
    title: {
      required: true,
      default: "",
    },
    description: {
      required: true,
      default: "",
    },
  },
};
